/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { RichText, isChildOfContainerContext } from './react'
import richTextFieldHasContent from '../../utils/rich-text-has-content'
import richTextStyles from './rich-text-styles'
import { ConditionalWrapper } from '../../utils/conditional-wrapper'

const SimpleContainer = ({ children, styling, ...props }) => (
  <div sx={{ mx: 'auto', maxWidth: '1200px', paddingX: 'sm', ...styling }} {...props}>
    <isChildOfContainerContext.Provider value={true}>{children}</isChildOfContainerContext.Provider>
  </div>
)

const HeaderFooterWrapper = ({
  heading,
  footer,
  headerStyles,
  footerStyles,
  headerContainerStyles,
  footerContainerStyles,
  children,
  wrapChildren,
}) => (
  <>
    <If condition={richTextFieldHasContent(heading)}>
      <ConditionalWrapper
        condition={wrapChildren}
        wrapper={SimpleContainer}
        styling={headerContainerStyles}
      >
        <RichText
          content={heading}
          style={{ display: 'block', pb: 'lg', ...richTextStyles, ...headerStyles }}
        />
      </ConditionalWrapper>
    </If>

    {children}

    <If condition={richTextFieldHasContent(footer)}>
      <ConditionalWrapper
        condition={wrapChildren}
        wrapper={SimpleContainer}
        styling={footerContainerStyles}
      >
        <RichText
          content={footer}
          style={{ display: 'block', pt: 'lg', ...richTextStyles, ...footerStyles }}
        />
      </ConditionalWrapper>
    </If>
  </>
)

export default HeaderFooterWrapper
